import {
  FOR_YOU_INTEREST_EXPIRATION_MS,
  FOR_YOU_INTEREST_KEY,
  FOR_YOU_INTEREST_UPDATED_EVENT,
} from './constants'
import { trackBadgeApplied } from './events'

interface ForYouInterest {
  categoryId: string
  browseNudgeDismissed: boolean
  setAt: number
}

// This is to avoid putting a global context provider on the whole app just for this experiment
export const dispatchForYouInterestUpdated = () => {
  if (typeof window !== 'undefined') {
    const event = new Event(FOR_YOU_INTEREST_UPDATED_EVENT)
    window.dispatchEvent(event)
  }
}

export const getForYouInterest = (): ForYouInterest | null => {
  if (typeof window === 'undefined') {
    return null
  }

  const forYouInterest: ForYouInterest | null = JSON.parse(
    window.localStorage.getItem(FOR_YOU_INTEREST_KEY) || 'null',
  )

  if (
    forYouInterest &&
    Date.now() - forYouInterest.setAt > FOR_YOU_INTEREST_EXPIRATION_MS
  ) {
    window.localStorage.removeItem(FOR_YOU_INTEREST_KEY)
    dispatchForYouInterestUpdated()
    return null
  }

  return forYouInterest
}

export const getForYouInterestCategoryId = (): string | null => {
  const forYouInterest = getForYouInterest()
  return forYouInterest && forYouInterest.categoryId
}

export const setForYouInterestIfUnset = ({
  categoryName,
  categoryId,
}: {
  categoryName?: string
  categoryId?: string
}) => {
  if (typeof window === 'undefined' || !categoryId) {
    return
  }

  const existingInterest = getForYouInterest()

  if (!existingInterest) {
    const newForYouInterest: ForYouInterest = {
      categoryId,
      browseNudgeDismissed: false,
      setAt: Date.now(),
    }

    window.localStorage.setItem(
      FOR_YOU_INTEREST_KEY,
      JSON.stringify(newForYouInterest),
    )
    dispatchForYouInterestUpdated()

    if (categoryName) {
      trackBadgeApplied(categoryName)
    }
  }
}

export const setBrowseNudgeDismissed = () => {
  if (typeof window === 'undefined') {
    return
  }

  const existingInterest = getForYouInterest()

  if (existingInterest) {
    const updatedForYouInterest: ForYouInterest = {
      ...existingInterest,
      browseNudgeDismissed: true,
    }

    window.localStorage.setItem(
      FOR_YOU_INTEREST_KEY,
      JSON.stringify(updatedForYouInterest),
    )
    dispatchForYouInterestUpdated()
  }
}
